import { ThemeProvider } from "@emotion/react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { createTheme } from "@mui/material/styles";
import FundDetailCards from "components/molecules/Card/FundDetailCards";
import WinnerLists from "components/molecules/List/WinnerLists";
import * as React from "react";
import "swiper/css";
import "swiper/css/pagination";
import useStyles from "./DetailsBody.styles";
const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#ddb930",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

const DetailsBody = () => {
  const classes = useStyles();
  const tickets = require("assets/tickets.png");
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box className={classes.main}>
          <img
            src={tickets}
            alt="tickets"
            style={{ width: "288px", height: "195px", marginBottom: "40px" }}
          />
          <FundDetailCards ethPrice={0.03} price={1200}/>
          <Box className={classes.discribeSection}>
            <Typography className={classes.titleText}>
              Next funding session
            </Typography>
            <Typography className={classes.detailText}>
              March 21st, 2022
            </Typography>
          </Box>
          <Box className={classes.discribeSection}>
            <Typography className={classes.titleText}>
              How the funding works
            </Typography>
            <Typography className={classes.detailText}>
              You will receive an invite for the next fund session around 2
              weeks before the event. It will occur online: the only thing
              you’ll need to do is to login on our app and follow the
              instructions you will receive from us.
            </Typography>
          </Box>
          <Box className={classes.winnerTitleSection}>
            <Typography className={classes.titleText}>
              Recent Winners
            </Typography>
            <Typography className={classes.viewMoreText}>View more</Typography>
          </Box>
          <Box className={classes.winnerSection}>
            <WinnerLists
              name={"@aaronandmams"}
              date={"October 21st, 2021"}
              ethPrice={"0.03ETH"}
              price={"$200"}
            />
            <WinnerLists
              name={"@aaronandmams"}
              date={"October 21st, 2021"}
              ethPrice={"0.03ETH"}
              price={"$200"}
            />
            <WinnerLists
              name={"@aaronandmams"}
              date={"October 21st, 2021"}
              ethPrice={"0.03ETH"}
              price={"$200"}
            />
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default DetailsBody;
